import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { QuoteSensitivity } from 'state/blotters/priceImprovement/priceImprovementBlotter.model';
import type { IHttpClient } from 'utils/http/httpClient.model';

export function quoteSensitivityApi(http: IHttpClient) {
  return {
    getSensitivity(quoteId: string): Observable<QuoteSensitivity> {
      return http
        .getJSON<QuoteSensitivity>({
          url: `api/v1/quote/${quoteId}/sensitivity`,
        })
        .pipe(map(response => response.payload));
    },
  };
}
